<mat-form-field floatLabel="always">
  <input
    matInput
    [mask]="mask"
    type="text"
    class="mobile-font-size input-text input-align input-text-editable"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (blur)="onRequestedAmountFocusOut()"
    [name]="controlIdentifier"
    [id]="controlIdentifier"
    #clra="ngModel"
    [pattern]="pattern"
    [required]="!!requiredError"
    [disabled]="disabled"
    [autocomplete]="autocomplete"
    (input)="onInput($event)"
  />
  <span matSuffix *ngIf="!!currency">{{ currency }}</span>
  <mat-error *ngIf="!!requiredError && clra.invalid && clra.errors.required">
    {{ requiredError }}
  </mat-error>
  <mat-error *ngIf="!!validationError && clra.invalid && clra.errors.pattern">
    {{ validationError }}
  </mat-error>
</mat-form-field>
